var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Box, Stack } from '@mui/material';
import styled from '@mui/material/styles/styled';
import Typography from '../../Typography';
import { DeleteIcon, EditIcon } from '../../icons';
import { CloudUploadIcon } from 'fbm-icons';
var DraggerBox = styled(Box)(function (_a) {
    var width = _a.width, height = _a.height, theme = _a.theme;
    return ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: width !== null && width !== void 0 ? width : 380,
        height: height !== null && height !== void 0 ? height : 146,
        backgroundColor: '#f5f5f5',
        border: '1px dashed rgba(0,0,0,0.08)',
        borderRadius: '4px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#EAEAEA'
        }
    });
});
var ImgWrapper = styled(Box)(function (_a) {
    var width = _a.width, height = _a.height;
    return ({
        position: 'relative',
        width: width !== null && width !== void 0 ? width : 380,
        height: height !== null && height !== void 0 ? height : 146,
        border: '1px solid transparent',
        borderRadius: '4px',
        overflow: 'hidden',
        '& .fbm-drop-mask': {
            backgroundColor: 'rgba(0,0,0,0.56)',
            position: 'absolute',
            inset: 0,
            display: 'none',
            justifyContent: 'center',
            alignItems: 'center',
        },
        '&:hover .fbm-drop-mask': {
            display: 'flex',
            cursor: 'pointer',
        },
        '& .upload-mask': {
            right: '50%',
        },
        '& .delete-mask': {
            left: '50%',
        },
        '& .line': {
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 1,
            height: '50%',
            backgroundColor: 'rgba(255,255,255,0.32)',
            zIndex: 1,
        },
    });
});
var Dragger = function (props) {
    var _a;
    var status = props.status, file = props.file, onRemove = props.onRemove, multiple = props.multiple, restProps = __rest(props, ["status", "file", "onRemove", "multiple"]);
    var imgUrl = (_a = file === null || file === void 0 ? void 0 : file.response) === null || _a === void 0 ? void 0 : _a.url;
    function handleRemove(e) {
        e.stopPropagation();
        onRemove === null || onRemove === void 0 ? void 0 : onRemove(file);
    }
    if (imgUrl && !multiple) {
        return (React.createElement(ImgWrapper, __assign({}, restProps),
            React.createElement("img", { src: imgUrl, width: "100%", height: "100%", style: { objectFit: 'cover' } }),
            React.createElement(Box, { className: "fbm-drop-mask upload-mask" },
                React.createElement(EditIcon, { htmlColor: "white" })),
            React.createElement(Box, { className: "fbm-drop-mask line" }),
            React.createElement(Box, { className: "fbm-drop-mask delete-mask", onClick: handleRemove },
                React.createElement(DeleteIcon, { htmlColor: "white" }))));
    }
    return (React.createElement(DraggerBox, __assign({}, restProps),
        React.createElement(Stack, { spacing: 0.5, alignItems: "center" },
            React.createElement(Typography, { variant: "caption", color: "secondary" },
                React.createElement(CloudUploadIcon, null)),
            React.createElement(Typography, { fontWeight: 500 }, "\u5C06\u6587\u4EF6\u62D6\u5230\u6B64\u5904\u4EE5\u4E0A\u4F20"),
            React.createElement(Stack, { direction: "row", spacing: 0.5, justifyContent: "center" },
                React.createElement(Typography, { variant: "caption", color: "secondary" }, "\u6216"),
                React.createElement(Typography, { variant: "caption", color: "#576B95" }, "\u9009\u53D6\u6587\u4EF6")))));
};
export default Dragger;
